import React from 'react'

export default function FaceFeature({ scaleX, fill }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M2 2.01001C2 2.01001 2.0099 2.01999 2.0199 2.04999"
        stroke={fill}
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M4.52002 5.07001C7.51002 8.09001 13.2201 12.25 21.9801 12.25C33.4101 12.25 39.97 6.45997 42.53 3.58997"
        stroke={fill}
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeDasharray="0.1 0.1"
      />
      <path
        d="M43.75 2.03998C43.77 2.01998 43.7699 2 43.7699 2"
        stroke={fill}
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
